import React from 'react';

import {  Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import {  ExpandMore } from '@mui/icons-material';

import FwdAssignments from '../../Fwds/FwdAssignments';

function GwFwdSection({ gatewayId }) {
    return (
        <>
            <Accordion defaultExpanded={false}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h7">FORWARDING ASSIGNMENTS</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FwdAssignments 
                        fetchRoute={`/fwd/assg/list/gateway/${gatewayId}`}
                        disableBreadcrumb={true}
                    />
                </AccordionDetails>
            </Accordion>
        </>   
    );
}

export default GwFwdSection;
